module.exports = __webpack_public_path__ + "static/img/6.a5b5461.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/eng/6.png
// module id = vbBA
// module chunks = 0